import { TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useTranslations } from 'next-intl';
import { RemovalConfirmationProps } from './types/RemovalConfirmation';

function RemovalConfirmation({ confirmRemoval, cancelRemoval }: RemovalConfirmationProps) {
  const t = useTranslations('RemovalConfirmation');

  return (
    <div>
      <p className="py-2 text-sm">{t('RemoveItemConfirmation')}</p>
      <div className="flex justify-between">
        <button type="button" onClick={cancelRemoval} className="ml-5 underline">
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={confirmRemoval}
          className="flex items-center justify-between gap-2 rounded-md bg-red p-2 px-3 text-white hover:bg-red2"
        >
          <TrashIcon className="h-5 w-5" />
          {t('Yes, remove')}
        </button>
      </div>
    </div>
  );
}

export default RemovalConfirmation;
